function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { cssVar, Tooltip as ChakraTooltip, forwardRef } from "../chakra/internal";
const $bg = cssVar('tooltip-bg');
const $arrowBg = cssVar('popper-arrow-bg');
const baseStyle = {
    [$bg.variable]: 'colors.background.neutral.tertiary.default',
    px: '8px',
    py: '5px',
    bg: [
        $bg.reference
    ],
    [$arrowBg.variable]: [
        $bg.reference
    ],
    color: 'colors.text.neutral.primary.default',
    borderRadius: 'md',
    fontWeight: 'normal',
    fontSize: '10px',
    boxShadow: 'md',
    maxW: '320px',
    zIndex: 'tooltip',
    _dark: {
        color: 'colors.text.neutral.primary.default',
        [$bg.variable]: 'colors.background.neutral.tertiary.default'
    }
};
export const ThemedTooltip = {
    baseStyle
};
const Tooltip = forwardRef((_param, ref)=>{
    var props = _extends({}, _object_destructuring_empty(_param));
    return /*#__PURE__*/ _jsx(ChakraTooltip, _object_spread({
        ref: ref
    }, props));
});
Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = {
    hasArrow: true,
    openDelay: 600
};
export { Tooltip };

//# sourceMappingURL=Tooltip.js.map